import React, { useEffect, useState } from 'react';
import { useAsyncDebounce } from 'react-table';
import { DebounceMsConfig } from '../../../config';
import { Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import clsx from 'clsx';
import { ErrorMessage } from 'formik';

export const ProgramEditBudget = ({
  setValue,
  initialValue,
  disabled,
  readOnly,
  isInvalid,
}: {
  setValue: (s: number | null | undefined) => void;
  initialValue: number;
  disabled: boolean;
  readOnly: boolean;
  isInvalid: boolean;
}) => {
  const [currentValue, setCurrentValue] = useState<number | string>(initialValue);
  const onChange = useAsyncDebounce((v) => {
    setValue(v ?? undefined);
  }, DebounceMsConfig.programEditInputDebounceMs);

  useEffect(() => {
    setCurrentValue(initialValue);
  }, [initialValue]);

  function handleChange(v: number | null | undefined) {
    setCurrentValue(v ?? '');
    onChange(v);
  }

  return (
    <Form.Group controlId="budget" className="growegy-form__row">
      <label className="growegy-form__label">Budget</label>
      <div>
        <CurrencyInput
          data-test="program-edit__budget"
          name="budget"
          id="buget-field"
          placeholder={disabled || readOnly ? '' : 'Add amount, $'}
          intlConfig={{ locale: 'en-US', currency: 'USD' }}
          disabled={disabled}
          readOnly={readOnly}
          allowDecimals={false}
          value={currentValue}
          onValueChange={(_v1, _v2, v) => handleChange(v?.float)}
          prefix="$"
          className={clsx('growegy-form__input', 'program-edit__input-redesigned--sized', {
            'is-invalid': isInvalid,
          })}
        />
        <ErrorMessage
          component="div"
          name="budget"
          className="invalid-feedback"
          data-test="program-edit__budget-validation-error"
        />
      </div>
    </Form.Group>
  );
};
